import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-comment\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path d=\"M21.99 4A2 2 0 0020 2H4a2.006 2.006 0 00-2 2v12a2.006 2.006 0 002 2h14l4 4zM18 14H6v-2h12zm0-3H6V9h12zm0-3H6V6h12z\" fill=\"#3d3d3d\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol